import { Search } from '@/components/Elements/Filter';
import { SectionHeading } from '@/components/Layout/SectionHeading';

import { ReviewedAdditionalPaymentsTable } from '../components/ReviewedAdditionalPaymentsTable/ReviewedAdditionalPaymentsTable';

export const Reviewed = () => {
  return (
    <>
      <SectionHeading title="Thanks for reviewing your additional compensation requests! 🚀" />
      <Search placeholder="Search by worker name" />
      <ReviewedAdditionalPaymentsTable />
    </>
  );
};
